import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideQueryService } from 'src/app/core/services/query.service';
import { IWaterSupplyZone, IWaterSupplyZoneGeo } from './water-supply-zone.model';
import { WATERSUPPLYZONE_ENDPOINT,  waterSupplyZoneStateConfig } from './water-supply-zone.config';
import { WaterSupplyZoneService } from './water-supply-zone.service';
import { WaterSupplyZoneRoutingModule } from './water-supply-zone-routing.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { WaterSupplyZoneGeoService } from './water-supply-zone-geo.service';
import { WATERSUPPLYZONE_GEO_ENDPOINT, waterSupplyZoneGeoStateConfig } from './water-supply-zone-all.config';
import { provideQueryWszService } from 'src/app/core/services/query-wsz.service';

@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<IWaterSupplyZone>(WATERSUPPLYZONE_ENDPOINT, waterSupplyZoneStateConfig),
    WaterSupplyZoneService,
    ...provideQueryWszService<IWaterSupplyZoneGeo>(WATERSUPPLYZONE_GEO_ENDPOINT, waterSupplyZoneGeoStateConfig),
    WaterSupplyZoneGeoService
  ],
  imports: [
    CommonModule,
    WaterSupplyZoneRoutingModule,
    GoogleMapsModule
  ]
})
export class WaterSupplyZoneModule { }
